module.exports = __webpack_public_path__ + "img/question10.f211b381.png";